import React, {Component} from 'react';
import {AisinoFormItem, AisinoRangePicker} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";

class FormItemRangePicker extends Component {
    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        return (
            <AisinoFormItem    {...this.props} {...formItemTailLayout}>
                <AisinoRangePicker {...this.props} style={styleBg?{background:"#ffffe6"}:{}}/>
            </AisinoFormItem>
        );
    }
}

export default FormItemRangePicker;
